import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export interface factorDetailsType {
  successCallback?: Function;
  errorCallback?: Function;
  resultKey?: string;
}

export default ({ errorCallback, resultKey = 'factorDetails', successCallback }: factorDetailsType) =>
  requestAsync({
    url: endpoints.getFactorDetailsUrl(),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getFactorDetailsUrl(),
    options: {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
      successCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
